import { useTranslation } from 'react-i18next'

interface ExchangeSummaryProps {
  newOrderId: string
  orderUrl?: string
}

const ExchangeSummary: React.FC<ExchangeSummaryProps> = ({
  newOrderId,
  orderUrl
}) => {
  const { t } = useTranslation()

  return (
    <div className="space-y-1">
      <p className="text-sm font-medium">{t('summary.new_order_id')}</p>
      {orderUrl ? (
        <a
          href={orderUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="block w-fit text-sm font-normal text-neutral-700 underline underline-offset-4"
        >
          {newOrderId}
        </a>
      ) : (
        <p className="text-sm font-normal text-neutral-700">{newOrderId}</p>
      )}
    </div>
  )
}

export default ExchangeSummary
